import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import './App.css';

function App() {
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('fc_auth') === '1') {
      setAuthenticated(true);
    }
  }, []);

  const handleLogin = (password) => {
    if (password === 'Fortitude83') {
      sessionStorage.setItem('fc_auth', '1');
      setAuthenticated(true);
      return true;
    }
    return false;
  };

  const handleLogout = () => {
    sessionStorage.removeItem('fc_auth');
    setAuthenticated(false);
  };

  return authenticated ? (
    <Dashboard onLogout={handleLogout} />
  ) : (
    <Login onLogin={handleLogin} />
  );
}

export default App;
